module.exports = __webpack_public_path__ + "static/media/sapo-cururu.17bcfcd3.mp3";